import { useEffect, useState } from "react";
import { useLanguage } from "../context/LanguageContext";

export default function ThemeToggle() {
  const getInitialTheme = () => {
    const savedTheme = localStorage.getItem("theme");
    if (savedTheme) return savedTheme;

    const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
    return prefersDark ? "dark" : "light";
  };

  const [theme, setTheme] = useState(getInitialTheme);
  const { language, toggleLanguage } = useLanguage();

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("theme", theme);
  }, [theme]);

  const handleToggleTheme = () => {
    setTheme((prev) => (prev === "light" ? "dark" : "light"));
  };

  const handleToggleLanguage = () => {
    toggleLanguage();
  };

  return (
    <div className="settingsDock">
      <button
        type="button"
        className="settingsDockButton languageDockButton"
        onClick={handleToggleLanguage}
        aria-label={language === "EN" ? "Cambiar a español" : "Cambiar a inglés"}
        title={language === "EN" ? "Cambiar a español" : "Cambiar a inglés"}
      >
        {language === "EN" ? "ES" : "EN"}
      </button>

      <button
        type="button"
        className={`settingsDockButton themeDockButton ${
          theme === "dark" ? "themeDockButtonDark" : ""
        }`}
        onClick={handleToggleTheme}
        aria-label={theme === "light" ? "Activar modo oscuro" : "Activar modo claro"}
        title={theme === "light" ? "Activar modo oscuro" : "Activar modo claro"}
      >
        <span className="themeDockIcon" aria-hidden="true" />
      </button>
    </div>
  );
}
